import { SquareArrowOutUpRight } from 'lucide-react'
import { UseFormReturn, useController } from 'react-hook-form'

import { ReceiverFormSchema } from '../../types'
import { ButtonIcon } from '@/ui/atoms/button/Button'
import { ExternalLinkButton } from '@/ui/atoms/link-button/LinkButton'
import { AddressInput } from '@/ui/molecules/address-input/AddressInput'

interface ControlledAddressInputProps {
  label?: string
  form: UseFormReturn<ReceiverFormSchema>
  blockExplorerUrl: string | undefined
  placeholder?: string
}

export function ControlledAddressInput({ label, form, blockExplorerUrl, placeholder }: ControlledAddressInputProps) {
  const { field } = useController({ control: form.control, name: 'receiver' })
  return (
    <AddressInput
      {...field}
      label={label}
      placeholder={placeholder}
      error={form.formState.errors.receiver?.message}
      postFix={
        blockExplorerUrl && (
          <ExternalLinkButton
            to={blockExplorerUrl}
            variant="transparent"
            size="s"
            className="mr-3 h-fit rounded-[1px] p-0 sm:mr-4"
          >
            <ButtonIcon icon={SquareArrowOutUpRight} />
          </ExternalLinkButton>
        )
      }
    />
  )
}
